/**
 * Shared confirm copy for removing a subscription item (Active Plans REMOVE
 * and Voice Base toggle-off). Keep in sync with SubscriptionButton / Pricing.
 */
export function buildRemoveSubscriptionConfirmMessage({
  planName,
  periodEndDate,
  isVoiceBase = false,
  planIsActive = true,
}) {
  let message = `⚠️ Remove "${planName}" from your subscription?\n\n`;

  if (!planIsActive) {
    message +=
      "🚨 WARNING: This plan is no longer available for new subscriptions.\n";
    message +=
      "If you cancel this subscription, you will NOT be able to re-add it later.\n\n";
  }

  message += `✅ You will continue to have access until ${periodEndDate}.\n`;
  message += "✅ No refund will be issued.\n";
  message += "✅ The item will not be rebilled on renewal.\n";
  message += `✅ You can change your mind and reinstate before ${periodEndDate}.\n`;
  if (isVoiceBase) {
    message +=
      "✅ Cancelling Voice Base also cancels Calendar / Recording / Text Chat.\n";
    message +=
      "✅ The Voice phone number is released (monthly number charge stops). This cannot be undone — you will get a new number if you subscribe again.\n";
  }
  message += "\nClick OK to confirm removal, or Cancel to keep this item.";
  return message;
}

export function confirmRemoveSubscriptionItem(opts) {
  return window.confirm(buildRemoveSubscriptionConfirmMessage(opts));
}
